import { Button, Message } from '@alifd/next';
import { Editor } from '@tinymce/tinymce-react';
import { Modal } from 'antd';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';

import styles from './index.module.scss';

const EditDocument = ({ name, style }) => {
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);

  const [content, setContent] = useState('<p>開始輸入內容...</p>');

  const editorRef = useRef<any>(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(
          `/ezcon/api/smartBuilding/regulations/${name}`,
          {
            headers: {
              authorization: window.localStorage.getItem('feathers-jwt'),
            },
          }
        );
        setContent(data.html);
      } catch (error) {
        console.log(error.response.data.displayMessage, '===error');
        console.error('error smartBuilding regulations:', error);
      }
    })();
  }, [openEditDialog, name]);

  const editDocument = async () => {
    console.log('Edited content:', content);
    try {
      const res = await axios.patch(
        `/ezcon/api/smartBuilding/regulations/${name}`,
        {
          html: content,
        },
        {
          headers: {
            authorization: window.localStorage.getItem('feathers-jwt'),
          },
        }
      );
      if (res.status === 204) {
        Message.success('規範內容已成功更新！');
        setOpenEditDialog(false);
      }
    } catch (error) {
      if (error.response.status === 404) {
        const res = await axios.post(
          `/ezcon/api/smartBuilding/regulations`,
          {
            name,
            html: content,
          },
          {
            headers: {
              authorization: window.localStorage.getItem('feathers-jwt'),
            },
          }
        );
        if (res.status === 204) {
          Message.success('規範內容已成功建立！');
          setOpenEditDialog(false);
        }
      }
      console.log(error.response, '===error editDocument');
      console.error('Error updating regulations:', error);
    }
  };

  return (
    <>
      <Button onClick={() => setOpenPreviewDialog(true)} style={style}>
        查看規範內容
      </Button>
      {/*查看*/}
      <Modal
        className={styles.dialog}
        title="規範內容預覽"
        open={openPreviewDialog}
        width="1000px"
        footer={[
          <Button
            key="edit"
            type="primary"
            style={{ marginRight: '10px' }}
            onClick={() => setOpenEditDialog(true)}
          >
            編輯規範內容
          </Button>,
          <Button key="back" onClick={() => setOpenPreviewDialog(false)}>
            關閉
          </Button>,
        ]}
        onCancel={() => setOpenPreviewDialog(false)}
      >
        {/* <Button
          style={{ marginBottom: '10px' }}
          onClick={() => setOpenEditDialog(true)}
        >
          編輯規範內容
        </Button> */}
        <div
          className={styles.showDocument}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      </Modal>
      {/*編輯*/}
      <Modal
        className={styles.dialog}
        title="管理規範"
        open={openEditDialog}
        width="1000px"
        okText="儲存"
        onOk={() => editDocument()}
        onCancel={() => setOpenEditDialog(false)}
      >
        <div className={styles.editDocumentContainer}>
          <Editor
            tinymceScriptSrc="https://cdn.jsdelivr.net/npm/tinymce@5/tinymce.min.js"
            onInit={(evt, editor) => {
              editorRef.current = editor;
            }}
            value={content}
            onEditorChange={(newValue) => {
              setContent(newValue);
            }}
            init={{
              height: 500,
              branding: false,
              // menubar: true,
              menubar: 'format',
              plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'table',
                'code',
                'fullscreen',
                'preview',
              ],

              toolbar:
                'undo redo | ' +
                'fontsizeselect fontselect | ' +
                'bold italic underline | ' +
                'forecolor backcolor | ' +
                'alignleft aligncenter alignright alignjustify | ' +
                'bullist numlist outdent indent | ' +
                'table',

              fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',

              font_formats:
                '微軟正黑體=Microsoft JhengHei;' +
                '新細明體=PMingLiU;' +
                '標楷體=DFKai-SB;' +
                'Arial=arial,helvetica,sans-serif;' +
                'Times New Roman=times new roman,times;',

              content_style: `
                body {
                  font-family: Microsoft JhengHei;
                  font-size: 14px;
                }
              `,
            }}
          />
        </div>
      </Modal>
    </>
  );
};

export default EditDocument;
